"use strict";
var __read = (this && this.__read) || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    }
    finally { if (e) throw e.error; }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uselessText = exports.placeholder = exports.formLayout = exports.splitSignal = exports.formatMonthStr = exports.formatDateStr = exports.tokenSeparators = exports.formatStr = exports.defaultListState = exports.defaultListData = exports.defaultPagination = exports.showTotal = exports.defaultPageInfo = exports.pageSizeOptions = exports.defaultTotal = exports.defaultPageSize = exports.defaultCurrent = exports.colorMap = void 0;
var defaultCurrent = 1;
exports.defaultCurrent = defaultCurrent;
var defaultPageSize = 10;
exports.defaultPageSize = defaultPageSize;
var defaultTotal = 0;
exports.defaultTotal = defaultTotal;
var pageSizeOptions = ['10', '50', '100', '1000', '5000'];
exports.pageSizeOptions = pageSizeOptions;
var showTotal = function (total, _a) {
  var _b = __read(_a, 2), start = _b[0], end = _b[1];
  return "\u7B2C" + start + "\uFF5E" + end + "\u6761\uFF0C\u5171" + total + "\u6761";
};
exports.showTotal = showTotal;
var defaultPagination = {
  showSizeChanger: true,
  defaultPageSize: defaultPageSize,
  defaultCurrent: defaultCurrent,
  pageSizeOptions: pageSizeOptions,
  showTotal: showTotal,
};
exports.defaultPagination = defaultPagination;
var defaultPageInfo = {
  currentPage: defaultCurrent,
  pageSize: defaultPageSize,
  total: defaultTotal,
};
exports.defaultPageInfo = defaultPageInfo;
var defaultListData = {
  list: [],
  pagination: {
    total: 0,
    currentPage: defaultCurrent,
    pageSize: defaultPageSize,
  },
};
exports.defaultListData = defaultListData;
var defaultListState = {
  data: defaultListData,
  error: null,
  loading: false,
};
exports.defaultListState = defaultListState;
var formatStr = 'YYYY年M月D日 HH:mm:ss';
exports.formatStr = formatStr;
var tokenSeparators = [',', '，', ';', '；', '\n', '\r', '\r\n'];
exports.tokenSeparators = tokenSeparators;
var splitSignal = ';';
exports.splitSignal = splitSignal;
var formatDateStr = 'YYYY-MM-DD';
exports.formatDateStr = formatDateStr;
var formatMonthStr = 'YYYY-MM';
exports.formatMonthStr = formatMonthStr;
var formLayout = {
  layout: {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  },
  emptyLayout: {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  },
  tailLayout: {
    wrapperCol: { offset: 0, span: 24 },
  },
};
exports.formLayout = formLayout;
var placeholder = '--';
exports.placeholder = placeholder;
var uselessText = '你可以的，你是最棒的小汪汪！';
exports.uselessText = uselessText;
var colorMap = {
  info: '#2db7f5',
  default: '#aaa',
  origin: '#8D95AA',
  error: '#FF5740',
  success: '#23C654',
  lightSuccess: '#87d068',
  warning: '#FFCC27',
  processing: '#108ee9',
  failed: '#cf1322',
  text: '#323233',
  secondaryText: '#8D95AA',
  placeholderText: '#A8AFC2',
  icon: '#BEC4D4',
  border: '#F2F4F8',
};
exports.colorMap = colorMap;
